import PropTypes from 'prop-types';
import React from 'react';
import ExpandIcon from '../ExpandIcon';

const AccordionLandingHeader = ({ onClick, expanded, headerText }) => (
  <div className="accordion-landing-header" onClick={onClick}>
    <span className="accordion-landing-header__text">{headerText}</span>
    <ExpandIcon expanded={expanded} />
  </div>
);

AccordionLandingHeader.propTypes = {
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  headerText: PropTypes.string.isRequired
};

export default AccordionLandingHeader;
